module.exports = {
        srcSet: __webpack_public_path__ + "static/media/person-400.06c9f0e4.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/person-400.06c9f0e4.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/person-400.06c9f0e4.webp",
        toString: function(){return __webpack_public_path__ + "static/media/person-400.06c9f0e4.webp"},
        
        width: 400,
        height: 400
      }